module.exports = __webpack_public_path__ + "assets/img/page2-design-side-nav-expanded-3-813df156.png";